import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Calendar from 'react-calendar/dist/entry.nostyle'
import moment from 'moment'
import { getLocaleByLang } from 'locale'
import Button from 'components/Button'
import _ from 'lodash'
import KanBoIcon from 'components/KanBoIcon'
import './Calendar.scss'
import classes from './DatePicker.module.scss'

export class DatePicker extends React.Component {
  static propTypes = {
    date: PropTypes.number,
    calendarProps: PropTypes.object,
    showHour: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,

    lang: PropTypes.number.isRequired,
  }

  static defaultProps = {
    showHour: false,
  }

  constructor (props) {
    super(props)

    this.state = {
      date: props.date ? new Date(props.date) : new Date(),
      selectedDate: false
    }

    this.handleDateChange = this.handleDateChange.bind(this)
    this.renderHours = this.renderHours.bind(this)
    this.renderHour = this.renderHour.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    if (
      nextProps.date &&
      nextProps.date !== this.props
    ) {
      this.setState({
        date: nextProps.date ? new Date(nextProps.date) : new Date()
      })
    }
  }

  componentWillUnmount () {
    clearInterval(this.timer)
  }

  handleDateChange (date) {
    const {
      onChange,
    } = this.props

    if (this.props.showHour) {
      this.setState({
        date,
        selectedDate: moment(date).format('YYYY-MM-DD')
      })
    } else {
      onChange(moment(date).hour(0).valueOf())
    }
  }

  handleSaveClick () {
    const {
      onChange,
    } = this.props
    const {
      selectedDate
    } = this.state

    this.setState({
      selectedDate: false
    })

    onChange(moment(selectedDate).hour(0).valueOf())
  }

  renderHours () {
    const hourMoment = moment().hour(0).minute(0)
    const timeFormat = hourMoment.localeData().longDateFormat('LT')

    const isAmPm = timeFormat.toLowerCase().indexOf('a') !== -1

    const format = isAmPm ? 'h A' : 'HH:mm'

    return (
      <div>
        <div className={classes.flexButtons}>
          {_.range(6).map(hour => this.renderHour(hour, format))}
        </div>
        <div className={classes.flexButtons}>
          {_.range(6, 12).map(hour => this.renderHour(hour, format))}
        </div>
        <div className={classes.flexButtons}>
          {_.range(12, 18).map(hour => this.renderHour(hour, format))}
        </div>
        <div className={classes.flexButtons}>
          {_.range(18, 24).map(hour => this.renderHour(hour, format))}
        </div>
      </div>
    )
  }

  renderHour (hour, format) {
    const {
      onChange,
    } = this.props
    const {
      selectedDate
    } = this.state

    return (
      <button
        key={hour}
        className={classes.flexButton + ' react-calendar__month-view__days__day react-calendar__tile'}
        onClick={() => {
          this.setState({
            selectedDate: false
          })

          onChange(moment(selectedDate).hour(hour).minute(0).valueOf())
        }}
      >
        {moment().hour(hour).minute(0).format(format)}
      </button>
    )
  }

  render () {
    const {
      lang,

      date,
      calendarProps,
      showHour,
      onChange,

      ...restProps
    } = this.props
    const {
      date: stateDate,
      selectedDate
    } = this.state

    return (
      <div {...restProps}>
        {!selectedDate ? (
          <Calendar
            {...calendarProps}
            showWeekNumbers
            locale={getLocaleByLang(lang)}
            value={stateDate}
            onChange={this.handleDateChange}
          />
        ) : (
          <div>
            {this.renderHours()}
            <Button
              block
              style={{ textAlign: 'left' }}
              bsStyle='primary'
              icon={<KanBoIcon name='kanbo-16-set-due-date' />}
              onClick={this.handleSaveClick}
            >
              <FormattedMessage id='SAVE' />
            </Button>
          </div>
        )}
      </div>
    )
  }
}

export default DatePicker
